import React from 'react'
import Hero from '../../components/Hero';
import { useIntl } from 'react-intl';
import NOMLinkBoxRow from '../../components/NOMLinkBoxRow';

export type NOM_019_SCFI_1998Props = {};

const NOM_003_SCFI_2014: React.FC<NOM_019_SCFI_1998Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero 
        bgImage={'/img/electronics-rs.jpg'} 
        heading={intl.formatMessage({
          id: "electronics",
          defaultMessage: "Electronics"
        })}
        subHeading={"NOM-003-SCFI-2014"} />
      <NOMLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-6 !pt-8">
        <h2 className="text-2xl text-secondary font-bold">NOM-003-SCFI-2014</h2>
        <p className='text-md font-bold'>
          {
            intl.formatMessage({
              id: 'security_spec',
              defaultMessage: 'Electrical and Electronic Products. Safety Specifications.'
            })
          }
        </p>
        <div className="flex flex-col gap-4 mt-4 mb-16">
          <p>
            {
              intl.formatMessage({
                id: 'security_spec_detail',
                defaultMessage: 'It applies to electrical products powered by public utility electricity as well as other energy sources—such as cells, batteries, accumulators, and self-generation—using alternating current and/or direct current, with a rated voltage of up to 1000 V AC and up to 1500 V DC.'
              })
            }
          </p>
          <h2 className="text-2xl text-secondary font-bold mb-8">
            {
              intl.formatMessage({
                id: 'mcb_scope',
                defaultMessage: 'Mexico Certifying Body has the following scope:'
              })
            }
          </h2>
          <div className='flex flex-col items-start gap-6 mb-0 md:mb-6'>
            <div className="flex flex-col gap-2 max-w-sm">
                <h3 className='font-bold text-main'>
                  {
                    intl.formatMessage({
                      id: 'nom003_scope_appliances',
                      defaultMessage: 'Aparatos electrodomésticos'
                    })
                  }
                </h3>
                <p>NMX-J-521/1-ANCE-2012</p>
                <p>NMX-J-521/2-2-ANCE-2019</p>
                <p>NMX-J-521-2-45-ANCE-2008</p>
                <p>NMX-J-521-2-32-ANCE-2017</p>
            </div>
            <div className="flex flex-col gap-2 max-w-sm">
                <h3 className='font-bold text-main'>
                  {
                    intl.formatMessage({
                      id: 'nom003_scope_tools',
                      defaultMessage: 'Herramientas eléctricas'
                    })
                  }
                </h3>
                <p>NMX-J-524/1-ANCE-2013</p>
                <p>NMX-J-524-2-1-ANCE-2009</p>
                <p>NMX-J-524-2-2-ANCE-2013</p>
            </div>
          </div>
        </div>
        <div className="w-full">
          <img src="/img/NOM003-electrodomesticos-herramientas.png" alt="NOM-003-SCFI-2014 Security of Data Processing Equipment" />
        </div>
      </div>
    </div>
  );
}

export default NOM_003_SCFI_2014;